export default __webpack_public_path__ + "static/media/item_3@2x.8fa4a7d5.webp";